import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Disable browser's native scroll restoration so it doesn't fight us
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Hash anchor: scroll to the element, not to top
      const tryScroll = () => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };
      // Give the page a frame to render before scrolling to anchor
      requestAnimationFrame(() => requestAnimationFrame(tryScroll));
      return;
    }

    // No hash: always reset to top immediately
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });

    // Second pass after paint — catches lazy-load / async layout shifts on mobile
    const raf = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    });

    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
